import React from 'react';

import { getPersonalDataItems } from '@xing-com/crate-lebenslauf-components';
import { useReadCoverLetter } from '@xing-com/crate-lebenslauf-hooks';

export const usePersonalData = (): JSX.Element[] => {
  const [data, setData] = React.useState<JSX.Element[]>([]);
  const coverLetter = useReadCoverLetter();

  React.useEffect(() => {
    const personalData = coverLetter?.personalInformation;
    const items = personalData ? getPersonalDataItems(personalData) : [];

    setData(items);
  }, [coverLetter?.personalInformation]);

  return data;
};
